import axios from "../api/axiosInstance";

export const GetAllCustomer = async () => {
    return await axios.get("/Customer/GetCustomerList");
};

export const GetCustomerById = async (id) => {
    return await axios.get("/Customer/GetCustomerById", {
        params: { id }
    });
};

export const AddCustomer = async (model) => {
    return await axios.post("/Customer/AddCustomer", model);
};

export const UpdateCustomer = async (model) => {
    return await axios.post("/Customer/UpdateCustomer", model);
};

export const RemoveCustomer = async (id) => {
    return await axios.post("/Customer/RemoveCustomer", null, {
        params: { id }
    });
};